import { Signal } from "@preact/signals";

export const waitForTask = (count: number, callback: () => void) => {
    let counter = 0;

    return () => {
        counter++;

        if (counter === count) {
            callback();
        }
    };
};

export function waitForMs(ms: number): Promise<void>;
export function waitForMs<T>(ms: number, resolveWith: T): Promise<T>;

export function waitForMs<T>(ms: number, resolveWith?: T) {
    return new Promise<T | undefined>((resolve) =>
        window.setTimeout(() => resolve(resolveWith), ms),
    );
}

export function waitForSignal<T>(signal: Signal<T>, value: T): Promise<T>;
export function waitForSignal<T>(signal: Signal<T>, values: T[]): Promise<T>;

export function waitForSignal<T>(signal: Signal<T>, valueOrValues: T | T[]) {
    const values = Array.isArray(valueOrValues)
        ? valueOrValues
        : [valueOrValues];

    return new Promise<T>((resolve) => {
        const dispose = signal.subscribe((newValue) => {
            if (values.includes(newValue)) {
                dispose();
                resolve(newValue);
            }
        });

        if (values.includes(signal.value)) {
            dispose();
            resolve(signal.value);
        }
    });
}
